import { render, staticRenderFns } from "./RightSide.vue?vue&type=template&id=4a15c00e&scoped=true&"
import script from "./RightSide.vue?vue&type=script&lang=js&"
export * from "./RightSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a15c00e",
  null
  
)

export default component.exports